import { render, staticRenderFns } from "./UpdatesEN.vue?vue&type=template&id=46edcde8&scoped=true&"
import script from "./UpdatesEN.vue?vue&type=script&lang=js&"
export * from "./UpdatesEN.vue?vue&type=script&lang=js&"
import style0 from "./UpdatesEN.vue?vue&type=style&index=0&id=46edcde8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46edcde8",
  null
  
)

export default component.exports